<template>
  <div id="SourceListPopover" v-loading="loading" @click.stop="$emit('handleClick')">
    <div class="content-box">
      <ul v-if="resource && resource.length" class="source-list-not-empty">
        <li class="source-item" v-for="(source,index) in resource" :key="index">
          <p class="source-name line-no-wrap">{{`${source.name}.${source.suffix}`}}</p>
          <p v-if="source.gjwCategoryNames" class="source-category line-no-wrap">分类： {{source.gjwCategoryNames}}</p>
        </li>
      </ul>
      <div v-else class="source-list-empty">
        <p>
          暂无可用资源，我们将联系厂商尽快提供
        </p>
      </div>
    </div>
    <div class="popover-tips">点击进入产品详情页下载构件资源</div>
  </div>
</template>

<script>
export default {
  name: 'SourceListPopover',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Array,
      default() {
        return []
      }
    }
  },
}
</script>

<style lang="less" scoped>
  #SourceListPopover{
    cursor: pointer;
  }
  .content-box{
    padding: 10px 12px;
  }
  .source-item{
    margin-bottom: 6px;
    .source-category{
      font-size: 0.86rem;
      color: @theme-text-light;
    }
  }
  .source-list-empty{
    color: @theme-grey-3;
    text-align: center;
  }
  .popover-tips{
    background: @bg-grey-dark;
    color: @theme-text-secondary;
    text-align: center;
    padding: 4px;
    font-size: 0.86rem;
  }
</style>
